import request from '@/utils/request'

// 新增列表
export function addList(data) {
  return request({
    url: '/business/feedback/add',
    method: 'post',
    data: data
  })
}